/** Aligns with ImportTableDefinition column transform rules (OpenAPI-serializable). */
export type CsvAnalysisTransformRule =
  | { kind: 'normalizeKana' }
  | { kind: 'normalizePhoneNumber'; country?: 'JP' }
  | { kind: 'padStart'; length: number; char: string }
  | { kind: 'normalizeDate'; format: string };

export namespace CsvAnalysisPayload {
  export interface AnalyzedColumn {
    name: string;
    inferredType: 'string' | 'number' | 'date' | 'boolean';
    inferredDestination: 'customer' | 'contract' | 'ignore';
    inferredTransformRules: CsvAnalysisTransformRule[];
    sampleValues: string[];
    confidence: 'high' | 'medium' | 'low';
  }

  export interface UniqueKeysDraft {
    customer?: { columnNames: string[]; identifierType: string };
    contract: { columnNames: string[] };
  }

  /** LLM を実行したときの実行メタ情報。LLM 未実行・失敗時は undefined。 */
  export interface LlmMeta {
    modelId: string;
    durationMs: number;
    usage: {
      promptTokens: number;
      completionTokens: number;
      totalTokens: number;
    };
  }
}

/** API の CSV 解析レスポンスに対応する DTO（OpenAPI: CsvAnalysisPayload） */
export type CsvAnalysisPayload = {
  fileId: string;
  detectedEncoding: 'utf-8' | 'shift_jis';
  detectedDelimiter: ',' | '\t' | '|';
  hasHeaderRow: boolean;
  columns: CsvAnalysisPayload.AnalyzedColumn[];
  uniqueKeysDraft: CsvAnalysisPayload.UniqueKeysDraft;
  rowCountEstimate: number;
  /** LLM 推定を実行した場合のみセットされる。 */
  llm?: CsvAnalysisPayload.LlmMeta;
};

/** OpenAPI 上の `CsvAnalysis`（CsvAnalysisPayload への参照と同一構造） */
export type CsvAnalysis = CsvAnalysisPayload;

export namespace CsvAnalysis {
  /** /files/analyze-stream の SSE イベント。フロント・バックで共有する。 */
  export type StreamEvent =
    | { type: 'reasoning-delta'; text: string }
    | { type: 'done'; analysis: CsvAnalysis }
    | { type: 'error'; message: string };
}

/** /files/analyze-stream でフロントから指定可能な LLM モデル ID（UI の選択肢と一致させる）。 */
export const CSV_ANALYZE_STREAM_MODEL_IDS = [
  //
  'gemini-2.5-flash',
  'gemini-2.5-pro',
  // 'gemini-3.1-pro-preview',
  // 'claude-opus-4-6',
] as const;

export type CsvAnalyzeStreamModelId = (typeof CSV_ANALYZE_STREAM_MODEL_IDS)[number];

/** 管理者向け UI の初期選択・推奨デフォルト。 */
export const CSV_ANALYZE_STREAM_DEFAULT_MODEL_ID: CsvAnalyzeStreamModelId = 'gemini-2.5-flash';

export const CSV_ANALYZE_STREAM_MODEL_OPTIONS: { value: CsvAnalyzeStreamModelId; label: string }[] = [
  { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash' },
  { value: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro' },
  // { value: 'gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro（プレビュー）' },
  // { value: 'claude-opus-4-6', label: 'Claude Opus 4.6' },
];
